export const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return re.test(email)
}

export const validatePassword = (password: string): string | null => {
  if (password.length < 8) {
    return 'Password must be at least 8 characters'
  }
  return null
}

export const validatePasswordMatch = (
  password: string,
  confirm: string,
): boolean => {
  return password === confirm
}

export const validateRequired = (
  value: string,
  fieldName: string,
): string | null => {
  if (!value || value.trim() === '') {
    return `${fieldName} is required`
  }
  return null
}

export const validateCellNumber = (number: string): boolean => {
  // Basic validation: allows digits, spaces, plus sign, dashes, parentheses
  // Must have at least 10 digits
  const digits = number.replace(/\D/g, '')
  return digits.length >= 10
}
